import { createFeatureSelector } from "@ngrx/store";
import { NavigationTab, NavMenuItem, NavMenuItemTypeEnum } from "FoxxyInterfaces";



export interface NavigationState {
    tabs: NavigationTab[];
    naventries: NavMenuItem[];

}

export const InitialNavigationState: NavigationState = {
    tabs: [
        // { displayName: 'Benachrichtigungen', url: '/notifications'}
    ],
    naventries: [  <NavMenuItem> { label: "Cockpit", routerlink: "/", icon: "desktop_mac", tooltip: "Cockpit", active: "active", seperator: false, type : NavMenuItemTypeEnum.default, notificationCount: 0, children: new Array<NavMenuItem>() } ]
};


export const navigationfeatureName = 'navigation';

export const selectNavigationState = createFeatureSelector<NavigationState>(navigationfeatureName);
